export const BOSSES = [
  { id: 1, name: 'Abyssal Sire', image: 'abyssalsire.png' },
  { id: 2, name: 'Alchemical Hydra', image: 'alchemicalhydra.png' },
  { id: 3, name: 'Argentavis', image: 'pvparenarank.png' },
  { id: 4, name: 'Barrows Chests', image: 'barrowschests.png' },
  { id: 5, name: 'Callisto', image: 'callisto.png' },
  { id: 6, name: 'Cerberus', image: 'cerberus.png' },
  { id: 7, name: "Chambers of Xeric", image: 'chambersofxeric.png' },
  { id: 8, name: "Chambers of Xeric (Olm Only)", image: 'chambersofxericchallenge.png' },
  { id: 9, name: 'Chaos Elemental', image: 'chaoselemental.png' },
  { id: 10, name: 'Chaos Fanatic', image: 'chaosfanatic.png' },
  { id: 11, name: 'Clue Scrolls (All)', image: 'cluescrollsall.png' },
  { id: 12, name: 'Clue Scrolls (Beginner)', image: 'cluescrollsbeginner.png' },
  { id: 13, name: 'Clue Scrolls (Easy)', image: 'cluescrollseasy.png' },
  { id: 14, name: 'Clue Scrolls (Medium)', image: 'cluescrollsmedium.png' },
  { id: 15, name: 'Clue Scrolls (Hard)', image: 'cluescrollshard.png' },
  { id: 16, name: 'Clue Scrolls (Elite)', image: 'cluescrollselite.png' },
  { id: 17, name: 'Clue Scrolls (Master)', image: 'cluescrollsmaster.png' },
  { id: 18, name: 'Collections Logged', image: 'collectionslogged.png' },
  { id: 19, name: 'Commander Zilyana', image: 'commanderzilyana.png' },
  { id: 20, name: 'Corporeal Beast', image: 'corporealbeast.png' },
  { id: 21, name: 'Crazy Archaeologist', image: 'crazyarchaeologist.png' },
  { id: 22, name: 'Dagannoth Prime', image: 'dagannothprime.png' },
  { id: 23, name: 'Dagannoth Rex', image: 'dagannothrex.png' },
  { id: 24, name: 'Dagannoth Supreme', image: 'dagannothsupreme.png' },
  { id: 25, name: 'Demonic Gorilla', image: 'demonicgorilla.png' },
  { id: 26, name: 'Duke Sucellus', image: 'dukesucellus.png' },
  { id: 27, name: 'Fight Caves', image: 'fightcaves.png' },
  { id: 28, name: 'Galvek', image: 'galvek.png' },
  { id: 29, name: 'General Graardor', image: 'generalgraardor.png' },
  { id: 30, name: 'Giant Mole', image: 'giantmole.png' },
  { id: 31, name: 'Grotesque Guardians', image: 'grotesqueguardians.png' },
  { id: 32, name: 'Inferno', image: 'inferno.png' },
  { id: 33, name: 'Kalphite Queen', image: 'kalphitequeen.png' },
  { id: 34, name: 'King Black Dragon', image: 'kingblackdragon.png' },
  { id: 35, name: 'Kraken', image: 'kraken.png' },
  { id: 36, name: "Kree'Arra", image: 'kreearra.png' },
  { id: 37, name: "K'ril Tsutsaroth", image: 'kriltsutsaroth.png' },
  { id: 38, name: 'The Nightmare', image: 'nightmare.png' },
  { id: 39, name: 'Leviathan', image: 'leviathan.png' },
  { id: 40, name: 'Nex', image: 'nex.png' },
  { id: 41, name: 'Ophidia', image: 'ophidia.png' },
  { id: 42, name: 'Phantom Muspah', image: 'phantommuspah.png' },
  { id: 43, name: 'Sarachnis', image: 'sarachnis.png' },
  { id: 44, name: 'Scorpia', image: 'scorpia.png' },
  { id: 45, name: 'Skotizo', image: 'skotizo.png' },
  { id: 46, name: 'The Gauntlet', image: 'thegauntlet.png' },
  { id: 47, name: 'The Corrupted Gauntlet', image: 'thecorruptedgauntlet.png' },
  { id: 48, name: 'Theatre of Blood', image: 'theatreofblood.png' },
  { id: 49, name: 'Thermonuclear Smoke Devil', image: 'thermonuclearsmokedevil.png' },
  { id: 50, name: 'Tombs of Amascut', image: 'tombsofamascut.png' },
  { id: 51, name: 'Vardorvis', image: 'vardorvis.png' },
  { id: 52, name: 'Venenatis', image: 'venenatis.png' },
  { id: 53, name: "Vet'ion", image: 'vetion.png' },
  { id: 54, name: 'Vorkath', image: 'vorkath.png' },
  { id: 55, name: 'The Whisperer', image: 'whisperer.png' },
  { id: 56, name: 'Wintertodt', image: 'wintertodt.png' },
  { id: 57, name: 'Zulrah', image: 'zulrah.png' },
  { id: 58, name: 'Yama', image: 'yama.png' },
  { id: 59, name: 'Delve', image: 'delve.png' },
];

export const getBossById = (id) => BOSSES.find(boss => boss.id === id) || BOSSES[0];
